import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import SoftCard from '../SoftCard/SoftCard';
import ASoftCard from '../ASoftCard/ASoftCard';
import CardIndex from '../../card/CardIndex/CardIndex';
import {
  getRecommendGroup,
  getGuessLikes,
  getRecoRecommend,
  getRecoOtherTop,
} from '../../actions/recommend';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';
import styles from './CommReco.module.less';

const selectGroups = createSelector(
  state => state.recommend,
  recommend => recommend.commGroups,
);
const selectRecoOtherTop = createSelector(
  state => state.recommend,
  recommend => recommend.recoOtherTop,
);

const selectGuessLikes = createSelector(
  state => state.recommend,
  recommend => recommend.guessLike,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectRecoRecommend = createSelector(
  state => state.recommend,
  recommend => recommend.recoOtherRecommend,
);

const pageSize = 60;
const showSize = 24;
export default memo(({ logInfo }) => {
  const dispatch = useDispatch();

  const recoOtherTop = useSelector(selectRecoOtherTop);
  const groupsData = useSelector(selectGroups);
  const guessLikesData = useSelector(selectGuessLikes);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);
  const recoRecommend = useSelector(selectRecoRecommend);

  const [showGuessLikes, setShowGuessLikes] = useState([]);

  useEffect(() => {
    if (
      !(
        recoOtherTop &&
        recoOtherTop.data &&
        recoOtherTop.data.length > 0 &&
        recoOtherTop.pageType === 'upgradeTop' &&
        logInfo.tag === 'Update'
      )
    ) {
      dispatch(getRecoOtherTop({ pageType: 'upgradeTop', tag: logInfo.tag }));
    }
  }, []);

  useEffect(() => {
    if (
      !(
        groupsData &&
        groupsData.dataList &&
        groupsData.dataList.length > 0 &&
        groupsData.pageType === 'upgrade' &&
        groupsData.tag === logInfo.tag
      )
    ) {
      dispatch(getRecommendGroup({ pageType: 'upgrade', tag: logInfo.tag }));
    }
  }, []);

  useEffect(() => {
    // if (
    //   logInfo.hotSall &&
    //   (!recoRecommend ||
    //     !recoRecommend.data ||
    //     !recoRecommend.data.length ||
    //     recoRecommend.pageType !== 'upgrade')
    // ) {
    //   dispatch(getRecoRecommend({ pageType: 'upgrade', tag: logInfo.tag }));
    // }
    if (logInfo.hotSall) {
      dispatch(getRecoRecommend({ pageType: 'upgrade', tag: logInfo.tag }));
    }
  }, []);

  useEffect(() => {
    if (!guessLikesData || !guessLikesData.apps || guessLikesData.limit !== pageSize) {
      dispatch(getGuessLikes({ skip: 0, limit: pageSize }));
    } else {
      const show_Apps = sortSoftsByLocalSoftInit(guessLikesData.apps || [], localSoftsInit);
      setShowGuessLikes(show_Apps);
    }
  }, [dispatch, guessLikesData, localSoftsInit]);

  return (
    <div className={styles.comm}>
      {recoOtherTop &&
        recoOtherTop.pageType === 'upgradeTop' &&
        recoOtherTop.data &&
        recoOtherTop.data.length > 0 &&
        logInfo.tag === 'Update' && (
          <React.Fragment>
            {recoOtherTop.data.map((item, i) => (
              <CardIndex data={{ ...item }} key={i} logInfo={{ ...logInfo, tag: logInfo.tag }} />
            ))}
          </React.Fragment>
        )}
      {showGuessLikes && showGuessLikes.length > 0 && (
        <div className={styles.comm_guess}>
          <div className={styles.comm_guess_header}>
            <div className={styles.comm_guess_header_title}>试试这些有用的软件吧</div>
            {/* <Link
            className={styles.comm_guess_header_link}
            onClick={() => {
              handleShowMore();
            }}
            to={{ pathname: `${CONTEXT}/guesslikesmore` }}
          >
            查看更多
          </Link> */}
          </div>
          <div className={styles.comm_guess_cards}>
            {showGuessLikes.slice(0, 18).map((soft, j) =>
              soft.androidType === '1' ? (
                <ASoftCard
                  soft={{ ...soft, cardShowDesc: true }}
                  logInfo={{
                    source: `${logInfo.tag}_Try`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  }}
                  key={j}
                />
              ) : (
                <SoftCard
                  soft={{ ...soft, cardShowDesc: true }}
                  logInfo={{
                    source: `${logInfo.tag}_Try`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  }}
                  key={j}
                />
              ),
            )}
          </div>
        </div>
      )}
      <div className={styles.comm_groups}>
        {/* group */}
        {groupsData &&
          groupsData.dataList &&
          groupsData.dataList.length > 0 &&
          groupsData.pageType === 'upgrade' &&
          groupsData.dataList.map((item, i) => (
            <CardIndex data={item} key={i} logInfo={{ ...logInfo, tag: logInfo.tag }} />
          ))}
      </div>
      {logInfo.hotSall &&
        recoRecommend &&
        recoRecommend.pageType === 'upgrade' &&
        recoRecommend.data &&
        recoRecommend.data.length > 0 && (
          <React.Fragment>
            {recoRecommend.data.map((item, i) => (
              <CardIndex data={{ ...item }} key={i} logInfo={{ ...logInfo, tag: logInfo.tag }} />
            ))}
          </React.Fragment>
        )}
    </div>
  );
});
